import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import '../../App.css';
import { styled } from '../../components/styled';
import SpText from '../../components/atoms/SpText';
import SpDialog from '../../components/atoms/SpDialog';
import SpButton from '../../components/atoms/SpButton';
import { ArrowBack, DeleteForever, DragHandleOutlined } from '@material-ui/icons';
import moment from 'moment';
import { Button as MuiButton, FormControlLabel, Grid, Radio, TableCell } from '@material-ui/core';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { theme as themeStyle } from '../../components/theme';
import StationOpenRents from '../stations/stationRent/stationRentTabs/StationOpenRents';
import StationClosedRents from '../stations/stationRent/stationRentTabs/StationClosedRents';
import StationsForcedRefunds from '../stations/stationRent/stationRentTabs/StationsForcedRefunds';
import StationsUsers from '../stations/stationRent/stationRentTabs/StationsUsers';
import { createStation, findStationById, publishMess } from '../../models/actions/Stations';
import { endRent, endRentForcibly, findRentsByStationId, getRentTotal, removeRent, updateRent } from '../../models/actions/Rents';
import { theme } from '../../components/theme';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import StationClosedRentDetailDialog from './stationRent/stationRentDetail/StationClosedRentDetailDialog';
import { updateBike } from '../../models/actions/Bikes';
import { confirmRentPayment } from '../../models/actions/Payment';
import { UserSessionContext } from '../../App';
import StationReportCreateModal from './stationReports/StationReportCreateModal';

//Tabs to be local to the component
const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent'
  },
  '& .MuiTabs-indicatorSpan': {
    maxWidth: 40,
    width: '100%',
    backgroundColor: '#FFF'
  }
});

const StyledTab = styled((props) => (
  <Tab
    disableRipple
    {...props}
  />
))(({ theme }) => ({
  textTransform: 'none',
  fontSize: '1.15rem',
  fontWeight: 600,
  marginRight: theme.spacing(1),
  color: 'rgba(255, 255, 255, 0.7)',
  '&.Mui-selected': {
    color: '#fff',
    fontSize: '1.25rem',
    fontWeight: 600
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#FFF'
  }
}));

const SpTab = ({ valueTab: value, setValueTab: setValue, refresh, setDialogUserPNOpen, setDialogEndRent, setSelectedRentDetailOpen, setRentConfirmationOpen, setForcedBikeLockDialog,setReportCreationOpen }) => {
  const tabLabels = [
    { id: 0, label: 'Noleggi aperti' },
    { id: 1, label: 'Noleggi chiusi' },
    { id: 2, label: 'Utenti' },
    { id: 3, label: 'Restituzioni forzate' }
  ];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ bgcolor: 'rgb(77, 172, 39, 0.8)' }}>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
        >
          {tabLabels.map((elem) => (
            <StyledTab
              label={elem.label}
              onClick={() => setValue(elem.id)}
            />
          ))}
        </StyledTabs>
        <div>
          {value === 0 && (
            <div
              value={value}
              role="tabpanel"
            >
              <StationOpenRents
                index={0}
                {...{ refresh, setDialogUserPNOpen, setDialogEndRent }}
              />
            </div>
          )}
          {value === 1 && (
            <div
              value={value}
              role="tabpanel"
            >
              <StationClosedRents
                index={1}
                {...{ refresh, setSelectedRentDetailOpen, setRentConfirmationOpen, setDialogEndRent, setDialogUserPNOpen,setReportCreationOpen }}
              />
            </div>
          )}
          {value === 2 && (
            <div
              value={value}
              role="tabpanel"
            >
              <StationsUsers
                index={2}
                {...{ setDialogEndRent, setDialogUserPNOpen, setRentConfirmationOpen, setSelectedRentDetailOpen }}
              />
            </div>
          )}
          {value === 3 && (
            <div
              value={value}
              ro
              le="tabpanel"
            >
              <StationsForcedRefunds
                index={3}
                {...{ refresh, setDialogUserPNOpen, setDialogEndRent, setForcedBikeLockDialog }}
              />
            </div>
          )}
        </div>
      </Box>
    </Box>
  );
};

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});
const CustomLockButton = styled('button')({
  cursor: 'pointer',
  borderRadius: 20,
  width: '50px',
  fontSize: '1.5rem',
  maxWidth: '40px',
  width: '100%',
  color: '#FFF',
  backgroundColor: theme.colors.mainGreen.main,
  ':&hover': {
    backgroundColor: theme.colors.mainGreen.main
  }
});

const StationRent = (props) => {
  const [currentStation, setCurrentStation] = useState();
  const [dialogUserPNOpen, setDialogUserPNOpen] = useState({ user: null, status: false });
  const [dialogEndRent, setDialogEndRent] = useState({ rent: null, station: null, bike: null, status: false });
  const [forcedBikeLockDialog, setForcedBikeLockDialog] = useState({ rent: null, station: null, bike: null, status: false, free_spots: [] });
  const [selectedRentDetailOpen, setSelectedRentDetailOpen] = useState({ rent: null, status: false });
  const [rentConfirmationOpen, setRentConfirmationOpen] = useState({ rent: null, status: false });
  const [rentsList, setRentsList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [valueTab, setValueTab] = useState(0);
  const [reportCreationOpen, setReportCreationOpen] = useState({rent:null,status: false });;

  const { authData, setAuthData } = useContext(UserSessionContext);

  const { stationId } = useParams();
  const history = useHistory();

  const { getValues } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const fetchData = async () => {
    if (stationId) {
      try {
        props.isLoading(true);
        const responseStation = await findStationById({ id_station: stationId }, authData.accessToken);
        responseStation && setCurrentStation(responseStation);
        const response = await findRentsByStationId({ id_station: stationId }, authData.accessToken);
        if (response) {
          setRentsList(response);
        }
        props.isLoading(false);
      } catch (error) {
        props.isLoading(false);
        props.snackbarShowErrorMessage(error);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const forcedBikeLock = async (position) => {
    try {
      forcedBikeLockDialog.rent.status = 'close';
      const rentUpdateResponse = await updateRent({ rent: forcedBikeLockDialog.rent }, authData.accessToken);
      if (rentUpdateResponse) {
        //if the update went well i open the lock
        const lockStationResponse = await publishMess({ station: forcedBikeLockDialog.station, action: { payload: `0${position}`, type: 'unlock' } }, authData.accessToken);
        if (lockStationResponse) {
          //assegno la nuova stazione e la nuova posizione nella stazione
          forcedBikeLockDialog.bike.station_position = position;
          forcedBikeLockDialog.bike.id_station = forcedBikeLockDialog.station.id; //Questo serve per aggiornare la posizione della bici nella nuova stazione in caso di bike sharing
          const response = await updateBike({ bike: { ...forcedBikeLockDialog.bike } }, authData.accessToken);
          if (response) {
            props.snackbarShowMessage(response.message);
            setForcedBikeLockDialog({ rent: null, station: null, status: false, free_spots: [] });
            setRefresh(!refresh);
          }
        }
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  const getRentTotalAmountToPay = async (rent_data) => {
    const resultsRentTotal = await getRentTotal({ rent_data: rent_data }, authData.accessToken);
    if (resultsRentTotal) {
      return resultsRentTotal;
    }
  };

  const forcedRentEnding = async () => {
    try {
      props.isLoading(true);
      //open the locks of the bikes
      let stringBikeToUnlock = '';
      const amount = await getRentTotalAmountToPay(dialogEndRent?.rent, authData.accessToken);
      //dialogEndRent?.rent?.bikes.map((elem, idx) => {
      //	stringBikeToUnlock = stringBikeToUnlock + (idx == dialogEndRent?.rent?.bikes.length || dialogEndRent?.rent?.bikes.length == 1) ? elem.number : `${elem.number}:`;
      //});
      //const lockStationResponse = await publishMess({ station: dialogEndRent.station, action: { payload: `0${stringBikeToUnlock}`, type: "unlock" } });
      //if (lockStationResponse) {
      const responseRentEnding = await endRentForcibly({ id_rent: dialogEndRent.rent.id, id_bike: dialogEndRent.bike.id, amount: amount }, authData.accessToken);
      if (responseRentEnding.message) {
        props.snackbarShowMessage(responseRentEnding.message);
        setDialogEndRent({ rent: null, station: null, bike: null, status: false });
        setRefresh(!refresh);
      } else {
        props.snackbarShowErrorMessage(responseRentEnding.error);
      }
      //}
      props.isLoading(false);
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  const handleRentConfirmation = async () => {
    try {
      const currentRent = rentConfirmationOpen.rent;
      currentRent.amount = rentConfirmationOpen.rent.amount;
      currentRent.status = 'close&confirmed';

      //add process asking for payment while confirming the rent
      const rentPaymentConfirmResponse = await confirmRentPayment({ rent: currentRent }, authData.accessToken);

      if (rentPaymentConfirmResponse) {
        currentRent.id_user_payment = rentPaymentConfirmResponse ? rentPaymentConfirmResponse.id_user_payment : currentRent.id_user_payment;
        const rentUpdateResponse = await updateRent({ rent }, authData.accessToken);
        if (rentUpdateResponse) {
          props.snackbarShowMessage('Noleggio confermato!');
          fetchData();
        }
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        {stationId && (
          <Grid
            item
            container
            xs={12}
            spacing={1}
            justifyContent="flex-end"
          >
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Ebike'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push({ pathname: `/stations/edit/${stationId}/ebikes`, state: { stationData: getValues() && stationId ? getValues() : currentStation } })}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Noleggi'}
                style={{ maxWidth: '40%', backgroundColor: theme.colors.mainGreen.secondary, color: 'white' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/rents`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Prenotazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reservations`)}
              />
            </Grid>
            <Grid
              item
              xs={'auto'}
            >
              <SpButton
                buttonType="accept"
                text={'Segnalazioni'}
                style={{ maxWidth: '40%' }}
                ariant="h1PageTitle"
                onClick={() => history.push(`/stations/edit/${stationId}/reports`)}
              />
            </Grid>
          </Grid>
        )}
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push('/stations')}
                style={{ width: 25, color: themeStyle.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {`Home / Stazione / ${currentStation?.name} / Noleggi `}
              </SpText>
            </TitleToolbarSection>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
        >
          <Grid
            item
            xs={12}
          >
            <SpTab {...{ valueTab, refresh, setValueTab, setDialogUserPNOpen, setDialogEndRent, setSelectedRentDetailOpen, setRentConfirmationOpen, setForcedBikeLockDialog,setReportCreationOpen }} />
          </Grid>
        </Grid>
      </Grid>
      <SpDialog
        style={{ padding: '1%' }}
        open={dialogUserPNOpen.status}
        setOpen={() => setDialogUserPNOpen({ user: null, status: false })}
        title={'Chiama utente'}
      >
        <SpText variant="text">{`Il numero dell'utente è: ${dialogUserPNOpen?.user?.phone_number}`}</SpText>
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={dialogEndRent.status}
        setOpen={() => setDialogEndRent({ rent: null, station: null, bike: null, status: false })}
        title={'Termina noleggio'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{'Sei sicuro di voler interrompere il pagamento di questo utente per questa bici?'}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'SI'}
                buttonType="accept"
                onClick={() => forcedRentEnding()}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'NO'}
                buttonType="accept"
                onClick={() => {
                  setDialogEndRent({ rent: null, station: null, bike: null, status: false });
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={forcedBikeLockDialog.status}
        setOpen={() => setForcedBikeLockDialog({ rent: null, station: null, status: false, free_spots: [] })}
        title={'Termina noleggio'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{'Clicca sul luccheto da sbloccare per la riconsegna.'}</SpText>
          </Grid>
          {forcedBikeLockDialog?.free_spots.length > 0 ? (
            <Grid
              item
              container
              xs={12}
              justifyContent={'flex-start'}
            >
              {forcedBikeLockDialog?.free_spots.map((e, idx) => (
                <Grid
                  item
                  xs={1}
                >
                  <CustomLockButton
                    buttonType="accept"
                    onClick={() => forcedBikeLock(e.station_position)}
                  >
                    {e.station_position}
                  </CustomLockButton>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid
              item
              container
              xs={12}
            >
              <SpText variant="text">Non ci sono lucchetti da aprire!</SpText>
            </Grid>
          )}
        </Grid>
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={selectedRentDetailOpen.status}
        setOpen={() => setSelectedRentDetailOpen({ rent: null, status: false })}
        title={'Dettaglio Noleggio'}
      >
        <StationClosedRentDetailDialog selectedRent={selectedRentDetailOpen.rent} />
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={rentConfirmationOpen.status}
        setOpen={() => setRentConfirmationOpen({ rent: null, status: false })}
        title={'Conferma Noleggio'}
      >
        <Grid
          container
          direction="column"
          spacing={2}
        >
          <Grid
            item
            xs={12}
          >
            <SpText variant="text">{`Sei sicuro di voler confermare questo noleggio? Confermando addebitera  ${rentConfirmationOpen?.rent?.rent_amount ? rentConfirmationOpen?.rent?.rent_amount.toString() : 0}€  all'utente.`}</SpText>
          </Grid>
          <Grid
            item
            container
            xs={12}
            alignItems={'flex-start'}
          >
            <Grid
              item
              xs={4}
            >
              <SpButton
                text={'CONFERMA'}
                buttonType="accept"
                onClick={() => handleRentConfirmation()}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ marginBottom: '1%' }}
            >
              <SpButton
                text={'ANNULLA'}
                buttonType="accept"
                onClick={() => {
                  setRentConfirmationOpen({ rent: null, status: false });
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </SpDialog>
      <SpDialog
        style={{ padding: '1%' }}
        open={reportCreationOpen.status}
        setOpen={() => setReportCreationOpen({ rent: null, station: null, bike: null, status: false })}
        title={'Apri una segnalazione'}
      >
        <StationReportCreateModal setReportCreationOpen={setReportCreationOpen} reportCreationOpen={reportCreationOpen}/>
      </SpDialog>
    </>
  );
};

export default withSnackbar(StationRent);
